import React from "react";
import Title from "../Blocks/Title";
import styles from "./Picture.module.css";
import EmbedOptions from "../../editorPage/EmbedOptions.json";
import Image from "../Blocks/Image";
import Video from "../Blocks/Video";

export default function Picture({ id, data }) {
	const getBlock = (mediaType) => {
		switch (mediaType) {
			case EmbedOptions.Image:
				return <Image src={data.src} />;
			case EmbedOptions.Video:
				return <Video src={data.src} />;

			default:
				return <></>;
		}
	};
	return (
		<div id={id} className={styles.picture}>
			<Title title={data.title} alignment={data.alignTitle} />
			<div className={styles.media}>{getBlock(data.mediaType)}</div>
		</div>
	);
}
